export const ADD = 'entities/stats/ADD';
